import { render, staticRenderFns } from "./RoundCloseNumbers.vue?vue&type=template&id=39074c76&scoped=true&"
import script from "./RoundCloseNumbers.vue?vue&type=script&lang=js&"
export * from "./RoundCloseNumbers.vue?vue&type=script&lang=js&"
import style0 from "./RoundCloseNumbers.vue?vue&type=style&index=0&id=39074c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39074c76",
  null
  
)

export default component.exports